import React from 'react'
import {Avatar,makeStyles} from '@material-ui/core'
// import DisplayDate from '../wall/DisplayDate'
import _ from 'lodash'
import moment from "moment";


const useStyles = makeStyles({
  avatar: {
    height:  35,
    width:  35,
    fontSize:  18,
    // border: index < 3 ? `solid 6px ${colors[index]}` : 'none',
  },
  name: {
    margin: 0,
    marginLeft: 10,
    fontWeight: 600,
    fontSize: 18
  }
})

export default function NotisItemAF({notis}) {
  const classes = useStyles()
  return (
    <div>
      {/* <div className='d-flex align-items-center mb-1'>
        <Avatar className={classes.avatar} src={notis.ProfilePicUrl}>
          { _.upperCase(notis.FirstName[0])}
          { _.isEmpty(notis.LastName)?"":_.upperCase(notis.LastName[0])}
        </Avatar>
        <p className={classes.name}>{`${_.capitalize(notis.FirstName)} ${_.capitalize(notis.LastName)}`}</p>

      </div> */}
      <div className="d-flex align-items-center mb-1 text-white">
          <Avatar className="m-1" src={notis.ProfilePicUrl}>
            { _.upperCase(notis.FirstName[0])}
            { _.isEmpty(notis.LastName)?"":_.upperCase(notis.LastName[0])}
          </Avatar>
          <div>
            <h5 className="m-0 pl-2 font-weight-bold">
              {`${_.capitalize(notis.FirstName)} ${_.capitalize(notis.LastName)}`} 
            </h5>
            <DisplayDate date={new Date(notis.sdate)} />
          </div>
      </div>
      <span style={{whiteSpace: 'pre-line'}}>
        {notis.text}
      </span>
    </div>
  )
}


const DisplayDate = ({date}) => {
  const postDate = moment(date, 'ddd MMM DD YYYY kk:mm:ss Z');
  const currentDate = moment(new Date());
  const duration = moment.duration(currentDate.diff(postDate));
  const minutes = (duration.asMinutes() | 0);
  const hours = (duration.asHours() | 0);

  switch (true) {
    case minutes === 0:
      return <small className="jr-text-white jr-fs-sm jr-mb-0 pl-2 text-white">Just nu</small>;
    case minutes < 60:
      return <small className="jr-text-white jr-fs-sm jr-mb-0 pl-2 text-white">{minutes} minuter sedan</small>;
    case hours < 24:
      return <small className="jr-text-white jr-fs-sm jr-mb-0 pl-2 text-white">{hours} timmar sedan</small>;
    default:
      return <small className="jr-text-white jr-fs-sm jr-mb-0 pl-2 text-white">{postDate.format("DD MMM, YYYY")}</small>
  }
}


